import React, { useEffect, useState } from 'react';
import { bucketS3, caminhoAnexosGestaoPaginaSimplesImagem } from 'constants/EnvironmentData';
import { IsMobileMaxWidth } from 'core/util/WindowSize';
import SimplesWithImageModel from 'models/generic-components/SecaoSimplesComOuSemImagem';
import {
    Button,
    ButtonContainer,
    DescriptionContainer,
    TitleText,
    MainContainer,
    Text,
    TitleContainer,
} from 'pages/home/components/FAQ/SuporteContainer.styled';

import Styled from './SimpleWithImage.styled';
import GenericComponentsUtils from '../generic-components.utils';
import { useHistory } from 'react-router';
import useLogged from 'hooks/useLogged';

interface ISimpleWithImage {
    dados: SimplesWithImageModel;
}

const SimpleWithImage = ({ dados }: ISimpleWithImage) => {
    const history = useHistory();
    const { authenticated } = useLogged();

    const getS3BaseUrl = (): string => {
        return bucketS3() + caminhoAnexosGestaoPaginaSimplesImagem();
    };

    const goToLink = (location: string) => {
        GenericComponentsUtils.gotoLink(location, history, authenticated, dados);
    };

    const buttonMobileText: string = IsMobileMaxWidth() ? 'Acessar' : 'Acessar cursos livres';

    return (
        <>
            {dados && (
                <>
                    {dados.orientacao ? (
                        <Styled.Container side={dados.orientacao}>
                            <Styled.PaddingImage src={getS3BaseUrl() + dados.filePath} />

                            <Styled.ContentContainer>
                                <Styled.Title>{dados.titulo}</Styled.Title>
                                <Styled.TextBox>
                                    <Styled.Text>{dados.descricao}</Styled.Text>
                                </Styled.TextBox>

                                <Styled.ButtonContainer>
                                    <Styled.Button
                                        onClick={() => {
                                            goToLink(dados.link ?? '');
                                        }}
                                    >
                                        {dados.textoBotaoA ?? buttonMobileText}
                                    </Styled.Button>
                                </Styled.ButtonContainer>
                            </Styled.ContentContainer>
                        </Styled.Container>
                    ) : (
                        <MainContainer>
                            <TitleContainer>
                                <TitleText>{dados.titulo}</TitleText>
                            </TitleContainer>
                            <DescriptionContainer>
                                <Text>{dados.descricao}</Text>
                            </DescriptionContainer>
                            <ButtonContainer>
                                <Button onClick={() => goToLink(dados.link ?? '')}> {dados.textoBotaoA ?? buttonMobileText}</Button>
                            </ButtonContainer>
                        </MainContainer>
                    )}
                </>
            )}
        </>
    );
};

export default SimpleWithImage;
